/** @format */
import {
    HeadingColor,
    HighlightColor,
} from '@mpb-com/feather/components/atoms/heading/types';

import { MediaQuery } from '@toucan/client/global/application';

import { CardBackgroundColor } from '@toucan/client/shared/components/card-background';

export const imageSizes = {
    [MediaQuery.MOBILE]: '360px',
    [MediaQuery.SMALL_TABLET]: '270px',
    [MediaQuery.DESKTOP]: '320px',
    default: '320px',
};

export const getHeadingColors = (variant?: CardBackgroundColor) => {
    switch (variant) {
        case CardBackgroundColor.MIDNIGHT:
            return {
                headingColor: HeadingColor.TEXT_INVERSE,
                highlightColor: HighlightColor.TEXT_ACCENT,
            };
        case CardBackgroundColor.PINK:
            return {
                headingColor: HeadingColor.TEXT_INVERSE,
                highlightColor: HighlightColor.TEXT_SECONDARY,
            };
        case CardBackgroundColor.SUSTAINABILITY:
            return {
                headingColor: HeadingColor.TEXT_INVERSE,
                highlightColor: undefined,
            };
        case CardBackgroundColor.WHITE:
        default:
            return {
                headingColor: HeadingColor.TEXT_SECONDARY,
                highlightColor: HighlightColor.TEXT_ACCENT,
            };
    }
};
